import { put, takeLatest } from "redux-saga/effects";
import {
  fetchRddsRequest,
  fetchRddsSuccess,
  fetchRddsFailure,
} from "./rddSlice";
import { fastApiURL } from "../../utils/config";

function* fetchRddsSaga() {
  try {
    const response = yield fetch(`${fastApiURL}/api/rdds`);

    if (!response.ok) {
      throw new Error(`Failed to fetch RDDs: ${response.status}`);
    }

    const data = yield response.json();

    const rdds = data.map((rdd) => ({
      id: rdd.id,
      name: rdd.name,
      image_url: rdd.image_url,
      color: rdd.color,
    }));

    yield put(fetchRddsSuccess(rdds));
  } catch (error) {
    console.error("Error in fetchRddsSaga:", error);
    yield put(fetchRddsFailure(error.message));
  }
}

export function* watchRddsSaga() {
  yield takeLatest(fetchRddsRequest.type, fetchRddsSaga);
}